/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Standard libraries
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
//UI
import { StyledBox, StyledContainer } from "@hcl-commerce-store-sdk/react-component";
//custom
import MenubarMenuItem from "./MenubarMenuItem";
import { styled } from "@mui/material";

interface ExpandedMenuProps {
  pages?: any;
}

/**
 * ExpandedMenu component
 * expanded menu for desktop/tablet view
 * @param props
 */
const StyledExpandedMenu= styled("header")`
  ${({ theme }) => `

    position: relative;
    z-index: -1;
    background-color: white;

    .categories-all-items-container {
      padding: 0;
    }

    `}
  `;


const ExpandedMenu: React.FC<ExpandedMenuProps> = (props: any) => {
  const { t } = useTranslation();
  const location: any = useLocation();
  const [selectedMenuItem, setSelectedMenuItem] = useState<any | null>(null);
  const { pages = [] } = props;
  const allCategories = {
    id: "allCategories",
    children: pages,
    name: t("AllCategoriesExpandedMenu.AllCategoriesLabel"),
  };
  const categories = [allCategories, ...pages];
  const selectMenuItem = (cid: string) => {
    setSelectedMenuItem(categories.filter((c) => c.id === cid)[0] || null);
  };

  React.useEffect(() => {
    setSelectedMenuItem(null);
  }, [location]);

  return (
    <StyledBox className="expanded-menu-container">
      <StyledExpandedMenu>
        <StyledContainer className="categories-all-items-container" overflow="hidden">
          <StyledBox
            display="flex"
            direction="row"
            flexWrap="nowrap"
            justifyContent="center"
            alignContent="center">
            {categories?.map((page: any) => (
              <MenubarMenuItem
                key={page.id}
                selectedMenuItem={selectedMenuItem}
                selectMenuItem={selectMenuItem}
                page={page}>
              </MenubarMenuItem>
            ))}
          </StyledBox>
        </StyledContainer>
      </StyledExpandedMenu>
    </StyledBox>
  );
};

export default ExpandedMenu;
